import Link from "next/link";
import { cn } from "@/lib/utils";

// konakla iOS uygulaması — App Store (TR). Resmi Apple logosu + Türkçe metinle
// gerçek App Store rozeti görünümü. (Şimdilik yalnız iOS; Android çıkınca eklenir.)
const APP_STORE_URL = "https://apps.apple.com/tr/app/konakla/id6783462177";

export function AppStoreBadge({ className }: { className?: string }) {
  return (
    <Link
      href={APP_STORE_URL}
      target="_blank"
      rel="noopener noreferrer"
      aria-label="konakla'yı App Store'dan indirin"
      className={cn(
        "inline-flex items-center gap-2 rounded-xl bg-black px-3.5 py-2 text-white transition-opacity hover:opacity-90",
        className
      )}
    >
      <svg viewBox="0 0 24 24" className="h-6 w-6 shrink-0" fill="currentColor" aria-hidden="true">
        <path d="M17.05 20.28c-.98.95-2.05.8-3.08.35-1.09-.46-2.09-.48-3.24 0-1.44.62-2.2.44-3.06-.35C2.79 15.25 3.51 7.59 8.02 7.36c1.35.07 2.29.74 3.08.8 1.18-.24 2.31-.93 3.57-.84 1.51.12 2.65.72 3.4 1.8-3.12 1.87-2.38 5.98.48 7.13-.57 1.5-1.31 2.99-2.5 4.03zM12.03 7.25c-.15-2.23 1.66-4.07 3.74-4.25.29 2.58-2.34 4.5-3.74 4.25z" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-[9px] font-normal opacity-90">İndirin</span>
        <span className="text-base font-semibold tracking-tight">App Store</span>
      </span>
    </Link>
  );
}
